"use strict";

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Action = function Action(_ref) {
  var primary = _ref.primary,
      secondary = _ref.secondary,
      tertiary = _ref.tertiary,
      children = _ref.children,
      className = _ref.className,
      component = _ref.component,
      props = _objectWithoutProperties(_ref, ["primary", "secondary", "tertiary", "children", "className", "component"]);

  var baseClass = "action";

  if (primary) {
    baseClass += "__primary";
  } else if (secondary) {
    baseClass += "__secondary";
  } else if (tertiary) {
    baseClass += "__tertiary";
  }

  var componentCls = (0, _classnames2.default)(baseClass, className);
  var Element = component || "a";

  return _react2.default.createElement(
    Element,
    _extends({}, props, { className: componentCls }),
    _react2.default.createElement(
      "span",
      null,
      children
    )
  );
};

Action.propTypes = process.env.NODE_ENV !== "production" ? {
  primary: _propTypes2.default.bool,
  secondary: _propTypes2.default.bool,
  tertiary: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  href: _propTypes2.default.string,
  to: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  children: _propTypes2.default.node.isRequired
} : {};

exports.default = Action;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cxagroup/casper/lib/components/action/action.js
// module id = 1351
// module chunks = 249